<template>
  <div :class="$style['guide-tab-wrapper']">
    <learning-center-guide-tab :search-query="searchQuery" />
  </div>
</template>

<script>
import LearningCenterGuideTab from '../../../../components/learningCenterGuideTab.vue';

export default {
  name: 'LearningCenterGuideTabWrapper',
  components: {
    LearningCenterGuideTab,
  },
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
  },
};
</script>

<style module lang="less">
@import "../../../../../../less/_variables.less";
@import "../../../../../../less/_mixins.less";

.guide-tab-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  :global(.learning-center-videos-tab-wrapper) {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    box-sizing: border-box;
    min-height: 0;
  }

  :global(.video-container) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    :global(#video-player) {
      width: 100%;
      max-width: 100%;
      border-radius: 4px;
    }

    :global(iframe) {
      width: 100%;
      max-width: 100%;
      border-radius: 4px;
    }
  }

  :global(.timeline-list) {
    position: relative;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;

    :global(.list-items) {
      width: 100%;
      flex: 1;
      padding-left: 0;
      overflow-y: auto;
      min-height: 0;
    }
  }
}
</style>

